import CornerMedium from "../../icons/CornerMedium";
import CornerSmall from "../../icons/CornerSmall";
import CornerLarge from "../../icons/CornerLarge";

export const TabsSettings = [
  { label: "Layout", value: "layout", i18n: "layout" },
  { label: "Content", value: "content", i18n: "content" },
];

export const ContentLoadSettings = [
  { label: "Dynamic", value: "dynamic", i18n: "dynamic" },
  { label: "Manual", value: "manually", i18n: "manual" },
];

export const CORNERS_OPTIONS = [
  { icon: CornerSmall, value: 1 },
  { icon: CornerMedium, value: 8 },
  { icon: CornerLarge, value: 20 },
];

export const NewsVariants = {
  CARD: "card",
  MAGAZINE: "magazine",
  LIST: "list",
  SHORT_LIST: "short_list",
};

export const BOOLEAN_OPTIONS = [
  { label: "Yes", i18n: "yes", value: true },
  { label: "No", i18n: "no", value: false },
];

export const BlogElements = {
  DESCRIPTION: "description",
  AUTHOR: "author",
  IMAGE: "image",
  DATE: "date",
  LABEL: "label",
  SPACE: "space",
};

export const DefaultActiveElements = [
  BlogElements.AUTHOR,
  BlogElements.LABEL,
  BlogElements.IMAGE,
  BlogElements.SPACE,
  BlogElements.DESCRIPTION,
  BlogElements.DATE,
];
